<template>
<div>
    <HeaderContent header="ตั้งค่าเว็บไซต์" :img_header="header_image" link_back="content" />
    <MenuContentSetting />
    <ContentContactList />
</div>
</template>

<script>
import HeaderImage from '@/assets/settings.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import MenuContentSetting from '@/components/menuadmin/content/contentsetting/MenuContentSetting.vue'
import ContentContactList from '@/components/menuadmin/content/contentsetting/ContentContactList.vue'

export default {
    name: 'contentContact',
    components: {
        HeaderContent,
        MenuContentSetting,
        ContentContactList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
